import { render, staticRenderFns } from "./CiDictionaryTableRow.vue?vue&type=template&id=aff62948&"
import script from "./CiDictionaryTableRow.vue?vue&type=script&lang=js&"
export * from "./CiDictionaryTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports